import React from 'react';
import { Grid, Row, Col } from '../utils/bootstrap';
import { Helmet } from 'react-helmet';
import Modal from '../components/Modal'

export default class PrivacyPolicy extends React.Component {
  render() {
    return (
      <Modal history={this.props.history}>
        <Helmet>
          <title>Privacy Promise | Business Finance You Can Trust | Premium Capital Partners</title>
          <meta name="description" content="Premium Capital Partners provide business finance you can trust. Explore our privacy promise and policies on how we handle confidential information." />
        </Helmet>
        <Grid>
          <Row>
            <Col xs={12}>
              <h3>Privacy Promise</h3>
              <p>
                While information is the cornerstone of our ability to provide superior service, our most
                important asset is our customers' trust. Keeping customer information secure, and using it
                only as our customers would want us to, is a top priority for all of us at Premium
                Capital. Here then, is our promise to our individual customers:
              </p>
              <ol>
                <li>
                  We will safeguard according to strict standards of security and confidentiality, any
                  information our customers share with us.
                </li>
                <li>
                  We will limit the collection and use of customer information to the minimum we require
                  to deliver superior service to our customers, which includes advising our customers
                  about our products, services and other opportunities, and to administer our business
                </li>
                <li>
                  We will permit only authorized employees, who are trained in the proper handling of
                  customer information, to have access to that information. Employees who violate our
                  Privacy Promise will be subject to our normal disciplinary process.
                </li>
                <li>
                  We will not reveal customer information to any external organization unless we have
                  previously informed the customer in disclosures or agreements, been authorized by the
                  customer or are required by law.
                </li>
                <li>
                  We will always maintain control over the confidentiality of our customer information. We
                  may, however, facilitate relevant offers from reputable companies. These companies are
                  not permitted to retain any customer information unless the customer has specifically
                  expressed interest in their products or services.
                </li>
                <li>
                  For purposes of credit reporting, verification and risk management, we will exchange
                  information about our customers with reputable reference sources and clearinghouse
                  services.
                </li>
              </ol>
            </Col>
          </Row>
        </Grid>
      </Modal>
    );
  }
}


// WEBPACK FOOTER //
// ./src/screens/PrivacyPolicy.js